import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';
import { loadState } from './sessionStorage';

var enhancers = compose(
  typeof window !== 'undefined' && window.devToolsExtension
    ? window.devToolsExtension()
    : function(store) {
        return store;
      }
);
const middleware = applyMiddleware(thunkMiddleware);
const persistedState = loadState();
const store = createStore(
  rootReducer,
  persistedState,
  compose(middleware, enhancers)
);
export default store;



// WEBPACK FOOTER //
// ./src/utils/store.js